import {
  experienceLevel as experienceLevels,
  translatorExperienceLevel,
  designerExperienceLevel,
  otherCategoryExperienceLevel
} from './../constant/form/form'

const getSelectedExperienceLevel = (
  category?: number | null,
  experienceLevel?: string
): string => {
  if (!category) return '--'
  if (!experienceLevel) return '--'

  switch (category) {
    case 1:
      return (
        experienceLevels.find(({ id }) => id === experienceLevel)?.title ?? '--'
      )

    case 2:
      return (
        designerExperienceLevel.find(({ id }) => id === experienceLevel)
          ?.title ?? '--'
      )

    case 3:
      return (
        translatorExperienceLevel.find(({ value }) => value === experienceLevel)
          ?.label ?? '--'
      )

    case 4:
      return (
        otherCategoryExperienceLevel.find(({ id }) => id === experienceLevel)
          ?.title ?? '--'
      )

    default:
      return (
        experienceLevels.find(({ id }) => id === experienceLevel)?.title ?? '--'
      )
  }
}

export default getSelectedExperienceLevel
